import { FC, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Menu } from 'antd';
import { HelperActions } from 'Store/Helper/Helper.actions';
import { useFeatureFlag } from 'Hooks/useFeatureFlag';
import { AuthUtils } from 'Utils/AuthUtils';
import { Icon, IconName } from 'Components/UI/Icon';
import { MenuStyled } from './styles';

interface IDropdownMenu {
  currentRole?: number;
  isSP?: boolean;
  historyPush: (path: string) => void;
}

interface IOptionsMenuProps {
  title: string;
  icon: IconName;
  customSize?: number;
  urlRedirect?: string;
  isLogout?: boolean;
  role?: number;
  isSP?: boolean;
  onModal?: () => void;
}

interface IRedirect {
  urlRedirect?: string;
  isLogout?: boolean;
  onModal?: () => void;
}

const DropdownMenu: FC<IDropdownMenu> = ({
  currentRole,
  isSP,
  historyPush,
}) => {
  const preferencesFeatureFlag = useFeatureFlag('preferences-feature');
  const preferencesFeature = preferencesFeatureFlag.enabled && preferencesFeatureFlag.value === 'test';

  const dispatch = useDispatch();

  const redirect = ({ urlRedirect, isLogout, onModal }: IRedirect) => {
    if (onModal) { return onModal(); }

    if (!urlRedirect) { return; }

    if (isLogout) {
      AuthUtils.logout();
      return historyPush(urlRedirect);
    }

    return historyPush(urlRedirect);
  };

  const openModal = () => {
    dispatch(HelperActions.toggleShowPreferencesModal(true));
  };

  const optionsMenu = useMemo(() => {
    const opts: IOptionsMenuProps[] = [{
      icon: 'menuGerenciarUsuario',
      title: 'Minha conta',
      urlRedirect: '/conta',
    }];

    if (preferencesFeature) {
      opts.push({
        icon: 'adjustments',
        customSize: 16,
        title: 'Preferências',
        onModal: openModal,
      });
    }

    opts.push(
      {
        icon: 'arquivoTxt',
        title: 'Faturamento',
        urlRedirect: '/faturamento',
        role: 1,
      },
      {
        icon: 'informacao',
        title: 'Sobre a Coordly',
        urlRedirect: '/sobre',
      },
      {
        icon: 'cadeado',
        title: 'Admin',
        urlRedirect: '/adm/tenants',
        isSP: true,
      },
      {
        icon: 'sair',
        title: 'Sair',
        urlRedirect: '/login',
        isLogout: true,
      },
    );

    return opts;
  }, [preferencesFeature]);

  return (
    <MenuStyled>
      {optionsMenu.map((opt) => (
        (!opt.role || (opt.role === currentRole)) && (!opt.isSP || (opt.isSP === isSP)) && (
          <Menu.Item
            key={`key-to-profile-opt-${opt.title}`}
            className='menuItem'
            onClick={() => redirect({
              urlRedirect: opt.urlRedirect,
              isLogout: opt.isLogout,
              onModal: opt.onModal,
            })}
          >
            <Icon
              icon={opt.icon}
              className='menuItemIcon'
              customSize={opt?.customSize ?? 15}
            />
            <p>{opt.title}</p>
          </Menu.Item>
        )
      ))}
    </MenuStyled>
  );
};

export default DropdownMenu;
